import { connect } from 'react-redux';

import { IVillageInfoProps, VillageInfo } from './index';
import { IState } from '../../store';
import { getVillageOffersType } from '../../utils/getVillageOffersType';

export function mapStateToProps(state: IState): IVillageInfoProps {
  const {
    villageData: { village },
    isFatCard,
    isCroppedCard,
    countrysideStationRegions,
    countrysideRoadRegions,
  } = state;

  return {
    regionHasRoads: !!village.regionId && countrysideRoadRegions.includes(village.regionId),
    regionHasStations: !!village.regionId && countrysideStationRegions.includes(village.regionId),
    village,
    isFatCard,
    isCroppedCard,
    offersType: getVillageOffersType(state),
  };
}

export const VillageInfoContainer = connect<IVillageInfoProps>(mapStateToProps)(VillageInfo);
